// Preprod pick: AWL-2671: disable FE MoEngage tracking; backend owns user attributes.
/**
 * FE-to-MoEngage is intentionally disabled.
 * Keep method signatures as no-op to avoid touching call sites.
 */
const noop = () => {};

const moengageConfig = {

    setUserAttributes: noop,

    profileChanges: noop,

    subscriptionDetailChanges: noop,

    trackEvent: noop,

};

export default moengageConfig;